import React from "react";

type PageHeaderProps = {
  children: React.ReactNode;
  title: string;
};

const PageHeader: React.FC<PageHeaderProps> = ({ children, title }) => (
  <>
    <h1 className="form-title">{title}</h1>
    <p className="form-description">{children}</p>
  </>
);

export default PageHeader;
